export const offboardingApiEndpoints = {
  list: { method: 'GET', path: '/staff/offboardings', requiresAuth: true },
  my: { method: 'GET', path: '/staff/offboardings/my', requiresAuth: true },
  summary: { method: 'GET', path: '/staff/offboardings/summary', requiresAuth: true },
  detail: { method: 'GET', path: '/staff/offboardings/:id', requiresAuth: true },
  create: { method: 'POST', path: '/staff/offboardings', requiresAuth: true },
  update: { method: 'PUT', path: '/staff/offboardings/:id', requiresAuth: true },
  remove: { method: 'DELETE', path: '/staff/offboardings/:id', requiresAuth: true },
  send: { method: 'POST', path: '/staff/offboardings/:id/send', requiresAuth: true },
  approve: { method: 'POST', path: '/staff/offboardings/:id/approve', requiresAuth: true },
  reject: { method: 'POST', path: '/staff/offboardings/:id/reject', requiresAuth: true },
  requestRevision: {
    method: 'POST',
    path: '/staff/offboardings/:id/request-revision',
    requiresAuth: true,
  },
  confirmDate: { method: 'POST', path: '/staff/offboardings/:id/confirm-date', requiresAuth: true },
  handoverConfirm: {
    method: 'POST',
    path: '/staff/offboardings/:id/confirm-handover',
    requiresAuth: true,
  },
  financeConfirm: {
    method: 'POST',
    path: '/staff/offboardings/:id/confirm-finance',
    requiresAuth: true,
  },
  confirmAccess: {
    method: 'POST',
    path: '/staff/offboardings/:id/confirm-access',
    requiresAuth: true,
  },
  complete: { method: 'POST', path: '/staff/offboardings/:id/complete', requiresAuth: true },
  completionEligibility: {
    method: 'GET',
    path: '/staff/offboardings/:id/completion-eligibility',
    requiresAuth: true,
  },
  hold: { method: 'POST', path: '/staff/offboardings/:id/hold', requiresAuth: true },
  resume: { method: 'POST', path: '/staff/offboardings/:id/resume', requiresAuth: true },
  cancel: { method: 'POST', path: '/staff/offboardings/:id/cancel', requiresAuth: true },
  tasks: { method: 'GET', path: '/staff/offboardings/:id/tasks', requiresAuth: true },
  createTask: { method: 'POST', path: '/staff/offboardings/:id/tasks', requiresAuth: true },
  updateTask: { method: 'PUT', path: '/staff/offboardings/:id/tasks/:taskId', requiresAuth: true },
  completeTask: {
    method: 'POST',
    path: '/staff/offboardings/:id/tasks/:taskId/complete',
    requiresAuth: true,
  },
  skipTask: {
    method: 'POST',
    path: '/staff/offboardings/:id/tasks/:taskId/skip',
    requiresAuth: true,
  },
  histories: { method: 'GET', path: '/staff/offboardings/:id/histories', requiresAuth: true },
  documents: { method: 'GET', path: '/staff/offboardings/:id/documents', requiresAuth: true },
  presignDocument: {
    method: 'POST',
    path: '/staff/offboardings/:id/documents/presign',
    requiresAuth: true,
  },
  storeDocument: {
    method: 'POST',
    path: '/staff/offboardings/:id/documents',
    requiresAuth: true,
  },
  removeDocument: {
    method: 'DELETE',
    path: '/staff/offboardings/:id/documents/:documentId',
    requiresAuth: true,
  },
} as const
